export const IMAGE_TYPE = "image";

export const SHOP_THIS_LOOK = "Shop this look";

export const HALFWAY_PERCENTAGE = 50;

export const COMPLETED_PERCENTAGE = 95;

export const IMAGES_CAROUSEL_REF = "imagesCarouselRef";
